import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './TurnosAsignados.css';
import EditStatusButton from '../EditStatusButton/EditStatusButton';

const TurnosAsignados = () => {
  const [turnos, setTurnos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);

  const fetchTurnos = async () => {
    try {
      setLoading(true);
      const response = await axios.get('/api/pacientes/turnos', {
        params: {
          page: page,
          limit: rowsPerPage,
          order: 'asc'
        }
      });
      
      setTurnos(response.data.data || []);
      setTotalRecords(response.data.pagination?.total_records || 0);
      setError(null);
    } catch (err) {
      console.error('Error fetching turnos:', err);
      setError('Error al cargar los turnos. Por favor, intente nuevamente.');
      // Set mock data for demonstration
      setTurnos([
        {
          _id: '64f2a1b8c9d4e5f6a7b8c9d0',
          estado: 'Con Turno Visita 1',
          fechaSeleccionada: '2025-09-28T09:00:00',
          riesgo: 'alto',
          documento: '12345678',
          nombre: 'María',
          apellido: 'González',
          telefono: '3001234567',
          estadoDelTurno: 'Confirmado'
        },
        {
          _id: '64f2a1b8c9d4e5f6a7b8c9d5',
          estado: 'Con Turno Visita 1',
          fechaSeleccionada: '',
          riesgo: 'muy bajo',
          documento: '44556677',
          nombre: 'Roberto',
          apellido: 'Jiménez',
          telefono: '3004455667',
          estadoDelTurno: 'Pendiente'
        }
      ]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTurnos();
  }, [page, rowsPerPage]);

  const handlePreviousPage = () => {
    if (page > 1) setPage(page - 1);
  };

  const handleNextPage = () => {
    if (turnos.length === rowsPerPage) setPage(page + 1);
  };

  const handleStatusUpdate = (dni, newStatus, fechaSeleccionada) => {
    setTurnos(prevTurnos => 
      prevTurnos.map(turno => 
        turno.documento === dni 
          ? { 
              ...turno, 
              estado: newStatus,
              fechaSeleccionada: fechaSeleccionada || turno.fechaSeleccionada 
            } 
          : turno
      )
    );
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'Sin fecha asignada';
    const options = { 
      year: 'numeric', 
      month: '2-digit', 
      day: '2-digit',
      timeZone: 'America/Argentina/Buenos_Aires' 
    };
    return new Date(dateString).toLocaleDateString('es-AR', options);
  };

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '20px' }}>
        <p>Cargando turnos...</p>
      </div>
    );
  }

  return (
    <div style={{ padding: '20px', maxWidth: '1200px', margin: '0 auto' }}>
      <h2 style={{ textAlign: 'center', marginBottom: '20px' }}>Turnos Asignados</h2>
      
      {error && (
        <div style={{ color: 'red', marginBottom: '15px', textAlign: 'center' }}>
          {error} Mostrando datos de ejemplo.
        </div>
      )}
      
      <div style={{ overflowX: 'auto' }}>
        <table style={{
          width: '100%',
          borderCollapse: 'collapse',
          border: '1px solid #ddd',
          borderRadius: '8px',
          overflow: 'hidden',
          marginBottom: '20px'
        }}>
          <thead>
            <tr style={{ backgroundColor: '#f5f5f5' }}>
              <th style={tableHeaderStyle}>Nombre</th>
              <th style={tableHeaderStyle}>Apellido</th>
              <th style={tableHeaderStyle}>Documento</th>
              <th style={tableHeaderStyle}>Teléfono</th>
              <th style={tableHeaderStyle}>Estado</th>
              <th style={tableHeaderStyle}>Fecha</th>
              <th style={tableHeaderStyle}>Riesgo</th>
              <th style={tableHeaderStyle}>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {turnos.map((turno) => (
              <tr key={turno._id} style={{ borderBottom: '1px solid #ddd' }}>
                <td style={tableCellStyle}>{turno.nombre}</td>
                <td style={tableCellStyle}>{turno.apellido}</td>
                <td style={tableCellStyle}>{turno.documento}</td>
                <td style={tableCellStyle}>{turno.telefono}</td>
                <td style={tableCellStyle}>{turno.estado}</td>
                <td style={tableCellStyle}>{formatDate(turno.fechaSeleccionada)}</td>
                <td style={tableCellStyle}>{turno.riesgo}</td>
                <td style={tableCellStyle}>
                  <EditStatusButton 
                    dni={turno.documento}
                    currentStatus={turno.estado}
                    onStatusUpdate={handleStatusUpdate}
                    paciente={turno}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div>
          <span>Mostrando {turnos.length} de {totalRecords || turnos.length} registros</span>
        </div>
        <div>
          <button 
            onClick={handlePreviousPage} 
            disabled={page === 1}
            style={paginationButtonStyle}
          >
            Anterior
          </button>
          <span style={{ margin: '0 10px' }}>Página {page}</span>
          <button 
            onClick={handleNextPage}
            disabled={turnos.length < rowsPerPage}
            style={paginationButtonStyle}
          >
            Siguiente
          </button>
        </div>
        <div>
          <select 
            value={rowsPerPage}
            onChange={(e) => setRowsPerPage(Number(e.target.value))}
            style={selectStyle}
          >
            <option value={5}>5 por página</option>
            <option value={10}>10 por página</option>
            <option value={25}>25 por página</option>
          </select>
        </div>
      </div>

    </div>
  );
};

// Style objects
const primaryButtonStyle = {
  backgroundColor: '#4a90e2',
  color: 'white',
  border: 'none',
  padding: '8px 16px',
  borderRadius: '4px',
  cursor: 'pointer',
  fontSize: '14px',
};

const tableHeaderStyle = {
  padding: '12px',
  textAlign: 'left',
  backgroundColor: '#4a90e2',
  color: 'white',
  fontWeight: 'bold',
};

const tableCellStyle = {
  padding: '12px',
  borderBottom: '1px solid #ddd',
};

const paginationButtonStyle = {
  padding: '8px 16px',
  backgroundColor: '#4a90e2',
  color: 'white',
  border: 'none',
  borderRadius: '4px',
  cursor: 'pointer',
  margin: '0 5px',
};

const selectStyle = {
  padding: '8px',
  borderRadius: '4px',
  border: '1px solid #ddd',
  fontSize: '14px',
};

export default TurnosAsignados;
